import styled from 'styled-components'

export const Header = styled.header`
  padding: 20px;
  background-color: ${props => props.bgColor};

  @media (max-width: 767px) {
    padding: 20px 16px;
  }
`

export const Container = styled.div`
  max-width: ${props => props.maxWidth};
  width: 100%;
  margin: 0 auto;
  display: flex;
`

export const NavItem = styled.div`
	font-family: Poppins,serif;
  color: white;
  font-size: 13px;
  text-align: center;
  line-height: 20px;
  padding: 0 10px 0 10px;
  letter-spacing: 2px;
  white-space: nowrap;
  cursor: pointer;
  
	&:hover {
			color: #4e4ba6;
		}
`


export const Logotipo = styled.img`
    @media (min-width: 1024px) {
   padding-right: 355px;
  }
`
